import React from 'react';
import classNames from 'classnames/bind';
import styles from './ProtocolInfoPanel.scss';
import { Button, SendIcon, DuplicateIcon, EditIcon, RouteIcon, Label, DeleteIcon, ReagentInfo, } from '@miroculus/nucleo';
import { editProtocolUrl, copyProtocolUrl, sendProtocolUrl, protocolRouteUrl, } from 'cons/routes';
import { useParams } from 'react-router-dom';
const cx = classNames.bind(styles);
const SmallSecondaryButton = (props) => (React.createElement(Button, { flavor: "secondary", size: "small", ...props }));
const ProtocolInfoPanel = ({ reagents = [], name, description, id, team, author, createdAt, time, permissions = {}, onDelete, }) => {
    const { teamId: teamToCopy } = useParams();
    return (React.createElement("aside", { className: cx('container') },
        React.createElement("section", { className: cx('main-info') },
            React.createElement(Label, null, "Protocol Name"),
            React.createElement("h2", null, name),
            React.createElement(Label, null, "Total run time"),
            React.createElement("h2", null, time),
            React.createElement("div", { className: cx('two-columns') },
                React.createElement(Label, null, "Author"),
                React.createElement("p", null, author),
                React.createElement(Label, null, "Created Date"),
                React.createElement("p", null, createdAt && new Date(createdAt).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                })))),
        React.createElement("section", { className: cx('description') },
            React.createElement(Label, null, "Description"),
            React.createElement("p", null, description)),
        React.createElement("section", { className: cx('reagents') },
            React.createElement(Label, null, "Reagents"),
            React.createElement("ul", null, reagents.map((reagent, key) => (React.createElement("li", { className: cx('reagent'), key: key },
                React.createElement(ReagentInfo, { name: reagent.description, volume: reagent.volume, dropgloss: reagent.jacketVol })))))),
        React.createElement("section", { className: cx('buttons') },
            permissions.canSeeRoutes && (React.createElement(SmallSecondaryButton, { to: protocolRouteUrl(team, id) },
                React.createElement(RouteIcon, null),
                " Routing")),
            permissions.canCopy && (React.createElement(SmallSecondaryButton, { to: copyProtocolUrl(teamToCopy, id) },
                React.createElement(DuplicateIcon, null),
                " Copy")),
            permissions.canEdit && (React.createElement(SmallSecondaryButton, { onClick: onDelete },
                React.createElement(DeleteIcon, null),
                " Delete")),
            permissions.canEdit && (React.createElement(SmallSecondaryButton, { to: editProtocolUrl(team, id) },
                React.createElement(EditIcon, null),
                " Edit")),
            permissions.canSend && (React.createElement(SmallSecondaryButton, { to: sendProtocolUrl(team, id) },
                React.createElement(SendIcon, null),
                " Send")))));
};
export default ProtocolInfoPanel;
